import { useCallback } from 'react'

const CDN_BASE = 'https://d2ql3aoebfyj3b.cloudfront.net/game/Quegudan2/sound'

const SOUND_URLS: Record<string, string> = {
  click: `${CDN_BASE}/click.mp3`,
  select: `${CDN_BASE}/select.mp3`,
  move: `${CDN_BASE}/move.mp3`,
  tie: `${CDN_BASE}/tie.mp3`,
  merge: `${CDN_BASE}/merge.mp3`,
  divide: `${CDN_BASE}/divide.mp3`,
  right: `${CDN_BASE}/right.mp3`,
  wrong: `${CDN_BASE}/wrong.mp3`,
}

export type SoundName = keyof typeof SOUND_URLS

export function useSound(enabled = true) {
  const play = useCallback(
    (name: SoundName) => {
      if (!enabled) return
      const url = SOUND_URLS[name]
      if (!url) return
      try {
        const audio = new Audio(url)
        audio.volume = 0.5
        audio.play().catch(() => {})
      } catch {
        // 무시
      }
    },
    [enabled],
  )

  return { play }
}
